module.exports = __webpack_public_path__ + "static/12-378c585e14084ce4043da696fe353d00.jpg";